import ProjectForm from "components/organisms/ProjectForm";

const ProjectsPage = () => {
    return <ProjectForm />;
};

export default ProjectsPage;
